(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('basic-slider')) {
  customElements.define('basic-slider', class BasicSlider extends HTMLElement {
    constructor() {
      super();
      // On utilise les nouveaux noms de classes uniques
      this.slider = this.querySelector('.basic-slider__slides'); 
      this.prevButton = this.querySelector('.basic-slider__button--prev');
      this.nextButton = this.querySelector('.basic-slider__button--next');
      this.slides = this.querySelectorAll('.basic-slider__slide');
      
      if (this.slides.length > 1) {
        this.currentIndex = 0;
        this.init();
      }
    }

    init() {
      this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
      this.nextButton.addEventListener('click', this.onNextClick.bind(this));
    }

    onPrevClick() {
      this.goToSlide(this.currentIndex - 1);
    }

    onNextClick() {
      this.goToSlide(this.currentIndex + 1);
    }

    goToSlide(index) {
      if (index < 0) {
        this.currentIndex = this.slides.length - 1;
      } else if (index >= this.slides.length) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = index;
      }
      
      this.slider.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0;
      this.translateY = 0; 
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      
      this.onScrollHandler = () => {
          if (!this.ticking) {
              window.requestAnimationFrame(() => {
                  this.onScroll();
                  this.ticking = false;
              });
              this.ticking = true;
          }
      };

      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    
    setHeaderHeight() { 
      const headerWrapper = this.querySelector('.header-wrapper');
      if (!headerWrapper) return;
      const style = window.getComputedStyle(headerWrapper);
      const height = headerWrapper.offsetHeight;
      const marginTop = parseFloat(style.marginTop) || 0;
      const marginBottom = parseFloat(style.marginBottom) || 0;
      const totalHeight = height + marginTop + marginBottom;
      document.documentElement.style.setProperty('--header-height', `${totalHeight}px`); 
      this.style.height = `${totalHeight}px`;
      this.style.minHeight = `${totalHeight}px`;

      const mobileSpacer = document.querySelector('.mobile-header-spacer');
      if(mobileSpacer) {
         mobileSpacer.style.height = `${totalHeight}px`;
      }
    }

    disconnectedCallback() { this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const isMobile = window.innerWidth < 990;

      if (isMobile) {
          const menuDrawer = this.querySelector('header-drawer details');
          const searchDetails = document.querySelector('.header__mobile-search details');
          
          if ((menuDrawer && menuDrawer.hasAttribute('open')) || 
              (searchDetails && searchDetails.hasAttribute('open'))) {
              return;
          }

          const distance = Math.abs(scrollTop - this.currentScrollTop);
          const direction = scrollTop > this.currentScrollTop ? 'down' : 'up';
          const headerHeight = this.offsetHeight;

          if (scrollTop <= 0) {
              this.translateY = 0;
          } else if (direction === 'down') {
              this.translateY -= distance;
          } else {
              this.translateY += distance;
          }

          if (this.translateY > 0) this.translateY = 0;
          if (this.translateY < -headerHeight) this.translateY = -headerHeight;

          this.style.transform = `translateY(${this.translateY}px)`;
          
          const opacity = 1 - (Math.abs(this.translateY) / headerHeight);
          this.style.opacity = Math.max(0, Math.min(1, opacity));

      } else {
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          
          const isScrollDown = scrollTop > this.currentScrollTop;
          const scrollDistance = Math.abs(this.currentScrollTop - scrollTop);

          if (isScrollDown && scrollDistance <= 10) return; 

          if (scrollTop <= 50) {
              if (!this.headerIsAlwaysSticky) {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
              }
          } else if (isScrollDown && scrollTop > 150) {
              if (!this.headerIsAlwaysSticky) {
                  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                  this.closeMenuDisclosure();
                  this.closeSearchModal();
              }
          } else if (!isScrollDown && scrollTop > 150) {
              if (!this.headerIsAlwaysSticky) {
                  this.header.classList.add('shopify-section-header-sticky');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
          }
      }

      this.currentScrollTop = scrollTop;
    }
    
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((disclosure) => disclosure.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); if(this.searchModal) this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
class CustomCarouselController {
  constructor(container) {
    this.element = container;
    this.track = this.element.querySelector('.custom-carousel__track');
    if (!this.track) return;
    
    this.slides = Array.from(this.track.children);
    this.nextButton = this.element.querySelector('.custom-carousel__arrow--next');
    this.prevButton = this.element.querySelector('.custom-carousel__arrow--prev');
    this.dotsNav = this.element.querySelector('.custom-carousel__dots');

    this.isDragging = false;
    this.startPos = 0;
    this.startY = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.animationID = 0;
    this.currentIndex = 0;
    this.swipeDirection = null;

    this.hasAnimatedPeek = false;

    this.init();
  }

  init() {
    this.onResize = this.onResize.bind(this);
    const resizeObserver = new ResizeObserver(() => this.onResize());
    resizeObserver.observe(this.track);

    this.track.addEventListener('mousedown', this.touchStart.bind(this));
    this.track.addEventListener('touchstart', this.touchStart.bind(this), {passive: true});
    this.track.addEventListener('mouseup', this.touchEnd.bind(this));
    this.track.addEventListener('mouseleave', this.touchEnd.bind(this));
    this.track.addEventListener('touchend', this.touchEnd.bind(this));
    this.track.addEventListener('mousemove', this.touchMove.bind(this));
    this.track.addEventListener('touchmove', this.touchMove.bind(this), {passive: false});
  }

  onResize() {
    this.slidesToShow = this.getSlidesToShow();
    // Sécurité si slides vides
    if (this.slides.length === 0) return;
    
    this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
    this.totalPages = Math.ceil(this.slides.length / this.slidesToShow);
    this.currentPage = this.currentPage || 0;
    if (this.currentPage >= this.totalPages) this.currentPage = this.totalPages > 0 ? this.totalPages - 1 : 0;

    this.goToPage(this.currentPage, false);

    if (this.slides.length > this.slidesToShow) {
      if (this.dotsNav) this.dotsNav.parentElement.style.display = 'flex';
      this.setupDots();
      this.updateButtons();
      if(this.nextButton) this.nextButton.onclick = () => this.goToPage(this.currentPage + 1);
      if(this.prevButton) this.prevButton.onclick = () => this.goToPage(this.currentPage - 1);
      
      if (window.matchMedia('(min-width: 750px)').matches) {
        if(this.nextButton) this.nextButton.style.display = 'flex';
        if(this.prevButton) this.prevButton.style.display = 'flex';
      } else {
        if(this.nextButton) this.nextButton.style.display = 'none';
        if(this.prevButton) this.prevButton.style.display = 'none';
      }
    } else {
      if (this.nextButton) this.nextButton.style.display = 'none';
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.dotsNav) this.dotsNav.parentElement.style.display = 'none';
    }

    this.animatePeekaboo();
  }

  animatePeekaboo() {
    if (this.hasAnimatedPeek || window.matchMedia('(min-width: 750px)').matches || this.slides.length <= this.slidesToShow) {
      return;
    }

    this.hasAnimatedPeek = true;

    setTimeout(() => {
      const peekAmount = -60;
      this.track.style.transition = 'transform 0.8s cubic-bezier(0.25, 1, 0.5, 1)';
      this.track.style.transform = `translateX(${peekAmount}px)`;

      setTimeout(() => {
        this.track.style.transform = `translateX(0px)`;
      }, 1200);
    }, 1500);
  }

  getSlidesToShow() {
    if (window.matchMedia('(min-width: 750px)').matches) {
      const section = this.element.closest('.custom-carousel-section');
      if(section) {
          return parseInt(getComputedStyle(section).getPropertyValue('--carousel-products-per-view')) || 3;
      }
      return 3;
    }
    return 1.25;
  }

  goToPage(pageNumber, transition = true) {
    if (pageNumber < 0) pageNumber = 0;
    if (pageNumber >= this.totalPages) pageNumber = this.totalPages > 0 ? this.totalPages - 1 : 0;

    if (window.matchMedia('(max-width: 749px)').matches) {
      const newX = - (pageNumber * this.slideWidth);
      this.track.style.transition = transition ? 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)' : 'none';
      this.track.style.transform = `translateX(${newX}px)`;
      this.currentIndex = pageNumber;
      this.currentPage = Math.floor(pageNumber / this.slidesToShow);
    } else {
      const newX = - (pageNumber * this.slideWidth * this.slidesToShow);
      this.track.style.transition = transition ? 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)' : 'none';
      this.track.style.transform = `translateX(${newX}px)`;
      this.currentPage = pageNumber;
      this.currentIndex = pageNumber * this.slidesToShow;
    }
    this.updateButtons();
    this.updateDots();
  }

  setupDots() {
    if (!this.dotsNav) return;
    this.dotsNav.innerHTML = '';
    const totalDots = window.matchMedia('(max-width: 749px)').matches ? this.slides.length : this.totalPages;
    for (let i = 0; i < totalDots; i++) {
      const button = document.createElement('button');
      button.classList.add('custom-carousel__dot');
      button.addEventListener('click', () => {
        this.goToPage(i);
      });
      this.dotsNav.appendChild(button);
    }
    this.updateDots();
  }

  updateButtons() {
    if (!this.prevButton || !this.nextButton) return;
    if (window.matchMedia('(max-width: 749px)').matches) {
      this.prevButton.disabled = this.currentIndex === 0;
      this.nextButton.disabled = this.currentIndex >= this.slides.length - 1;
    } else {
      this.prevButton.disabled = this.currentPage === 0;
      this.nextButton.disabled = this.currentPage >= this.totalPages - 1;
    }
  }

  updateDots() {
    if (!this.dotsNav) return;
    const activeDotIndex = window.matchMedia('(max-width: 749px)').matches ? this.currentIndex : this.currentPage;
    Array.from(this.dotsNav.children).forEach((dot, index) => {
      dot.classList.toggle('custom-carousel__dot--active', index === activeDotIndex);
    });
  }

  getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }

  getPositionY(event) {
    return event.type.includes('mouse') ? event.pageY : event.touches[0].clientY;
  }

  touchStart(event) {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    this.isDragging = true;
    this.startPos = this.getPositionX(event);
    this.startY = this.getPositionY(event);
    this.animationID = requestAnimationFrame(this.animation.bind(this));
    this.track.style.transition = 'none';
    this.track.classList.add('is-grabbing');
  }

  touchMove(event) {
    if (!this.isDragging) return;

    const currentX = this.getPositionX(event);
    const currentY = this.getPositionY(event);
    const diffX = currentX - this.startPos;
    const diffY = currentY - this.startY;

    if (this.swipeDirection === null) {
      if (Math.abs(diffX) > 10 || Math.abs(diffY) > 10) {
        this.swipeDirection = Math.abs(diffX) > Math.abs(diffY) ? 'horizontal' : 'vertical';
      }
    }

    if (this.swipeDirection === 'horizontal') {
      if(event.cancelable) event.preventDefault();
      this.currentTranslate = this.prevTranslate + diffX;
    }
  }

  touchEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    cancelAnimationFrame(this.animationID);
    this.track.classList.remove('is-grabbing');

    if (this.swipeDirection === 'horizontal') {
      const movedBy = this.currentTranslate - this.prevTranslate;
      if (movedBy < -50 && this.currentIndex < this.slides.length - 1) {
        this.currentIndex += 1;
      }
      if (movedBy > 50 && this.currentIndex > 0) {
        this.currentIndex -= 1;
      }

      this.prevTranslate = -this.currentIndex * this.slideWidth;
      this.currentTranslate = this.prevTranslate;
      this.track.style.transition = 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)';
      this.track.style.transform = `translateX(${this.prevTranslate}px)`;
      this.updateDots();
    }

    this.swipeDirection = null;
  }

  animation() {
    if (this.swipeDirection === 'horizontal') {
      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
    }
    if (this.isDragging) requestAnimationFrame(this.animation.bind(this));
  }
}

let carouselInstances = new Map();
function initCarousel(sectionId) {
  const container = document.querySelector(`#shopify-section-${sectionId} .custom-carousel__container`);
  if (container) {
    // Nettoyage préalable pour éviter les doublons
    if (carouselInstances.has(sectionId)) {
       carouselInstances.delete(sectionId);
    }
    carouselInstances.set(sectionId, new CustomCarouselController(container));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-carousel-section').forEach(section => {
    initCarousel(section.id.replace('shopify-section-', ''));
  });
});
document.addEventListener('shopify:section:load', (event) => {
  initCarousel(event.detail.sectionId);
});
document.addEventListener('shopify:section:unload', (event) => {
  const sectionId = event.detail.sectionId;
  if (carouselInstances.has(sectionId)) {
    carouselInstances.delete(sectionId);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-swiper"] && !Shopify.designMode) return;
  try {
    
  class ProductSwiper_V16 {
    constructor(element) {
      this.element = element;
      this.apiUrl = this.element.dataset.apiUrl; 
      this.stack = this.element.querySelector('.swp16-stack');
      this.cards = Array.from(this.stack.querySelectorAll('.swp16-card'));
      
      this.seenIds = this.cards.map(c => c.dataset.productId).filter(id => id); 
      this.likedIds = [];
      this.isLoading = false;

      // --- LOGIQUE DE GOUTS UTILISATEUR ---
      this.userPreferences = {
          likedTypes: {}, 
          priceSum: 0,
          likedCount: 0
      };

      try {
        const fallbackScript = document.getElementById('swp16-fallback-data');
        this.shopData = fallbackScript ? JSON.parse(fallbackScript.textContent) : [];
      } catch(e) { this.shopData = []; }

      // --- INITIALISATION SEED UNIQUE ---
      this.initialShuffleWithMath();

      this.headerContainer = this.element.querySelector('.js-swp16-title');
      this.headerT1 = this.element.querySelector('.swp16-t1');
      this.headerT2 = this.element.querySelector('.swp16-t2');
      
      this.likeButton = this.element.querySelector('.swp16-btn-like');
      this.dislikeButton = this.element.querySelector('.swp16-btn-dislike');
      this.viewButton = this.element.querySelector('.swp16-btn-view');
      this.successOverlay = this.element.querySelector('.swp16-success');

      this.rAF = null; 
      this.cachedRect = null;
      this.isDragging = false;
      this.startPos = { x: 0, y: 0 };
      this.currentPos = { x: 0, y: 0 };
      this.currencySymbol = '€'; 

      this.createLightbox();
      this.init();
    }

    // --- FORMULE MATHÉMATIQUE DE SEEDING (Mulberry32) ---
    // Cette fonction génère un nombre pseudo-aléatoire unique basé sur une seed
    mulberry32(a) {
        return function() {
          var t = a += 0x6D2B79F5;
          t = Math.imul(t ^ t >>> 15, t | 1);
          t ^= t + Math.imul(t ^ t >>> 7, t | 61);
          return ((t ^ t >>> 14) >>> 0) / 4294967296;
        }
    }

    initialShuffleWithMath() {
        if(this.shopData.length < 2) return;
        
        // Création de la seed basée sur le temps actuel + entropie
        const seed = Date.now() ^ (Math.random() * 0x100000000);
        const randomFunc = this.mulberry32(seed);

        // Algorithme de mélange Fisher-Yates utilisant le random seeded
        let currentIndex = this.shopData.length, randomIndex;
        while (currentIndex != 0) {
            // Utilisation de notre fonction random mathématique seeded
            randomIndex = Math.floor(randomFunc() * currentIndex);
            currentIndex--;
            [this.shopData[currentIndex], this.shopData[randomIndex]] = [
            this.shopData[randomIndex], this.shopData[currentIndex]];
        }
    }

    createLightbox() {
        const existing = document.querySelector('.swp16-lightbox-portal');
        if(existing) existing.remove();
        this.lightbox = document.createElement('div');
        this.lightbox.className = 'swp16-lightbox-portal';
        this.lightbox.innerHTML = `<div class="swp16-lightbox-close">&times;</div><img src="" alt="Zoom">`;
        document.body.appendChild(this.lightbox);
        this.lightboxImg = this.lightbox.querySelector('img');
        this.lightboxClose = this.lightbox.querySelector('.swp16-lightbox-close');
    }

    init() {
      if (this.cards.length < 3) this.fetchIDs();
      else {
          this.updateHeaderInfo(this.cards[0]); 
          this.cards.forEach(c => this.hydrateCard(c));
      }
      this.attachEventListeners();
      this.lightboxClose.addEventListener('click', () => this.closeLightbox());
      this.lightbox.addEventListener('click', (e) => { if(e.target === this.lightbox) this.closeLightbox(); });
    }

    hydrateCard(card) {
        this.initZoomLogic(card);
        this.initScrollArrows(card);
        this.initVariantLogic(card);
    }

    getCurrentCard() { return this.stack.querySelector('.swp16-card'); }

    updateHeaderInfo(card) {
        if(!card || !this.headerContainer) return;
        const fullTitle = card.dataset.title || "Produit";
        let t1Text = "";
        let t2Text = fullTitle;
        
        if(fullTitle.includes(' - ')) {
            const parts = fullTitle.split(' - ');
            t1Text = parts[0];
            t2Text = parts.slice(1).join(' - '); 
        } 
        
        if(this.headerT2.textContent === t2Text && this.headerT1.textContent === t1Text) return;

        this.headerContainer.classList.add('fade-out');
        setTimeout(() => {
            if(this.headerT1) this.headerT1.textContent = t1Text;
            if(this.headerT2) this.headerT2.textContent = t2Text;
            this.headerContainer.classList.remove('fade-out');
        }, 200);
    }

    generateOptionsHTML(options) {
        if (!options || options.length === 0) return '<div class="gpc-pill selected">Unique</div>';
        let html = '';
        const colorMap = { 'or':'#D4AF37', 'gold':'#D4AF37', 'or jaune':'#FFD700', 'or blanc':'#F0F8FF', 'or rose':'#B76E79', 'rose gold':'#B76E79', 'argent':'#C0C0C0', 'silver':'#C0C0C0', 'acier':'#71797E', 'noir':'#000000', 'black':'#000000', 'blanc':'#FFFFFF', 'white':'#FFFFFF', 'rouge':'#D32F2F', 'red':'#D32F2F', 'bleu':'#1976D2', 'blue':'#1976D2', 'vert':'#388E3C', 'green':'#388E3C', 'rose':'#F48FB1', 'pink':'#F48FB1', 'turquoise':'#40E0D0', 'marron':'#795548', 'violet':'#9C27B0', 'beige':'#F5F5DC', 'gris':'#9E9E9E', 'jaune':'#FFEB3B' };

        options.forEach((opt, index) => {
            const isColor = /color|couleur|teinte|finition/i.test(opt.name);
            opt.values.forEach((val, vIndex) => {
                const isSelected = vIndex === 0 ? 'selected' : ''; 
                if (isColor) {
                    const cleanVal = val.toLowerCase().trim();
                    let bgStyle = colorMap[cleanVal] || val;
                    const borderStyle = /blanc|white/.test(cleanVal) ? 'border:1px solid #ccc;' : '';
                    html += `<div class="gpc-swatch ${isSelected}" style="background-color: ${bgStyle}; ${borderStyle}" title="${val}" data-option-position="${opt.position}" data-value="${val.replace(/"/g, '&quot;')}"></div>`;
                } else {
                    html += `<div class="gpc-pill ${isSelected}" data-option-position="${opt.position}" data-value="${val.replace(/"/g, '&quot;')}">${val}</div>`;
                }
            });
            if (index < options.length - 1) html += '<div style="width:1px; height:15px; background:rgba(255,255,255,0.2); flex-shrink:0; margin:0 2px;"></div>';
        });
        return html;
    }

    checkBuffer() { 
        if (this.cards.length < 4 && !this.isLoading) this.fetchIDs(); 
    }

    fetchIDs() {
        this.isLoading = true;
        this.loadFallbackLocal();
    }

    loadFallbackLocal() {
        if (this.shopData.length === 0) { this.isLoading = false; return; }
        
        // 1. On filtre ce qu'on a déjà vu
        let available = this.shopData.filter(p => !this.seenIds.includes(String(p.id)));
        
        if(available.length === 0) {
            this.seenIds = []; 
            available = this.shopData;
        }

        // 2. SCORING DES PRODUITS (Algorithme)
        const scoredProducts = available.map(product => {
            let score = Math.random() * 100; // Aléatoire pure

            // Bonus TYPE
            if (product.type && this.userPreferences.likedTypes[product.type]) {
                score += (this.userPreferences.likedTypes[product.type] * 50); 
            }

            // Bonus PRIX
            if (this.userPreferences.likedCount > 0 && product.price_raw) {
                const avgPrice = this.userPreferences.priceSum / this.userPreferences.likedCount;
                const diff = Math.abs(product.price_raw - avgPrice);
                const percentDiff = diff / avgPrice;
                if(percentDiff < 0.2) score += 20; 
            }

            return { product, score };
        });

        // 3. Tri
        scoredProducts.sort((a, b) => b.score - a.score);

        // 4. Sélection
        const bestMatches = scoredProducts.slice(0, 3).map(item => item.product.id);
        
        this.buildCardsFromIDs(bestMatches);
        this.isLoading = false;
    }

    recordPreference(card) {
        const type = card.dataset.type;
        const price = parseFloat(card.dataset.price);

        if(type) {
            if(!this.userPreferences.likedTypes[type]) this.userPreferences.likedTypes[type] = 0;
            this.userPreferences.likedTypes[type]++;
        }
        if(!isNaN(price)) {
            this.userPreferences.priceSum += price;
            this.userPreferences.likedCount++;
        }
    }

    buildCardsFromIDs(ids) {
        ids.forEach(idStr => {
            const targetId = String(idStr);
            if(this.cards.some(c => c.dataset.productId === targetId)) return;

            const product = this.shopData.find(p => String(p.id) === targetId);
            if(!product) return;

            const el = document.createElement('article');
            el.className = 'swp16-card';
            el.dataset.productId = product.id;
            el.dataset.title = product.title;
            el.dataset.variantId = product.variantId;
            el.dataset.productUrl = product.url;
            el.dataset.type = product.type; 
            el.dataset.price = product.price_raw; 

            const optionsHTML = this.generateOptionsHTML(product.options);
            const imgSrc = product.image || "";

            el.innerHTML = `
                <div class="swp16-choice swp16-choice-no">NON</div>
                <div class="swp16-choice swp16-choice-yes">OUI</div>
                <div class="swp16-img-area">
                    <img src="${imgSrc}" class="swp16-img" loading="lazy" width="800" height="1066" alt="${product.title.replace(/"/g, '&quot;') || 'Produit'}">
                </div>
                <div class="swp16-footer">
                    <div class="swp16-footer-left"><span class="swp16-price">${product.price}</span></div>
                    <div class="swp16-footer-right">
                        <button class="swp16-arrow swp16-arrow-left"><svg viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button>
                        <div class="swp16-scroll-wrapper">${optionsHTML}</div>
                        <button class="swp16-arrow swp16-arrow-right"><svg viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></button>
                    </div>
                </div>`;

            if(product.variants) {
                const script = document.createElement('script');
                script.className = 'variant-data';
                script.type = 'application/json';
                script.textContent = JSON.stringify(product.variants);
                el.appendChild(script);
            }

            this.stack.appendChild(el);
            this.cards.push(el);
            this.seenIds.push(targetId);
            this.hydrateCard(el);
        });
        
        if(!this.getCurrentCard()) return;
        this.updateHeaderInfo(this.getCurrentCard());
    }

    initZoomLogic(card) {
        const imgArea = card.querySelector('.swp16-img-area');
        const img = card.querySelector('.swp16-img');
        if (!imgArea || !img) return;

        imgArea.addEventListener('click', () => {
            if(this.isDragging || Math.abs(this.currentPos.x) > 5) return;
            this.lightboxImg.src = img.src;
            this.lightbox.classList.add('is-open');
        });

        imgArea.addEventListener('mouseenter', () => {
             if(window.innerWidth > 768) this.cachedRect = imgArea.getBoundingClientRect();
        });

        imgArea.addEventListener('mousemove', (e) => {
            if(window.innerWidth <= 768 || !this.cachedRect) return;
            if (this.rAF) cancelAnimationFrame(this.rAF);
            
            this.rAF = requestAnimationFrame(() => {
                const x = ((e.clientX - this.cachedRect.left) / this.cachedRect.width) * 100;
                const y = ((e.clientY - this.cachedRect.top) / this.cachedRect.height) * 100;
                img.style.transformOrigin = `${x}% ${y}%`;
                img.style.transform = 'scale(2)';
            });
        });

        imgArea.addEventListener('mouseleave', () => { 
            if(window.innerWidth > 768) {
                if (this.rAF) cancelAnimationFrame(this.rAF);
                img.style.transform = 'scale(1)'; 
                this.cachedRect = null;
            }
        });
    }

    closeLightbox() { this.lightbox.classList.remove('is-open'); }

    initScrollArrows(card) {
        const scrollWrapper = card.querySelector('.swp16-scroll-wrapper');
        const l = card.querySelector('.swp16-arrow-left');
        const r = card.querySelector('.swp16-arrow-right');
        if(scrollWrapper && l && r) {
            l.onclick = (e) => { e.stopPropagation(); scrollWrapper.scrollBy({ left: -100, behavior: 'smooth' }); };
            r.onclick = (e) => { e.stopPropagation(); scrollWrapper.scrollBy({ left: 100, behavior: 'smooth' }); };
        }
    }

    initVariantLogic(card) {
       const script = card.querySelector('.variant-data');
       if(!script) return;
       try {
           const variants = JSON.parse(script.textContent);
           const image = card.querySelector('.swp16-img');
           const priceDisplay = card.querySelector('.swp16-price');
           const pills = card.querySelectorAll('.gpc-pill, .gpc-swatch');
           
           pills.forEach(pill => {
              pill.addEventListener('click', (e) => {
                 e.stopPropagation(); e.preventDefault();
                 if(pill.dataset.value === "Default") return;
                 
                 const group = pill.parentElement;
                 Array.from(group.children).forEach(s => {
                     if(s.dataset.optionPosition === pill.dataset.optionPosition) s.classList.remove('selected');
                 });
                 pill.classList.add('selected');
                 
                 const currentOptions = [null, null, null];
                 card.querySelectorAll('.selected').forEach(el => {
                    const pos = parseInt(el.dataset.optionPosition) - 1;
                    if(pos >= 0) currentOptions[pos] = el.dataset.value;
                 });
                 
                 const matchedVariant = variants.find(v => v.options.every((opt, i) => currentOptions[i] === null || currentOptions[i] === opt));
                 
                 if (matchedVariant) {
                     card.dataset.variantId = matchedVariant.id;
                     card.dataset.price = matchedVariant.price; 

                     if(priceDisplay) priceDisplay.textContent = (matchedVariant.price / 100).toFixed(2).replace('.', ',') + ' ' + this.currencySymbol;

                     if(matchedVariant.featured_image && image) {
                        image.removeAttribute('srcset');
                        image.removeAttribute('sizes');
                        let newSrc = matchedVariant.featured_image.src;
                        if (newSrc.startsWith('//')) newSrc = 'https:' + newSrc;
                        if (!image.src.includes(newSrc)) {
                            image.style.opacity = 0.6;
                            setTimeout(() => { image.src = newSrc; image.style.opacity = 1; }, 200);
                        }
                     }
                 }
              });
           });
       } catch(e) {}
    }

    attachEventListeners() {
      this.stack.addEventListener('mousedown', this.startDrag.bind(this));
      this.stack.addEventListener('touchstart', this.startDrag.bind(this), { passive: true });
      document.addEventListener('mousemove', this.onDrag.bind(this));
      document.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });
      document.addEventListener('mouseup', this.endDrag.bind(this));
      document.addEventListener('touchend', this.endDrag.bind(this));
      
      if(this.likeButton) this.likeButton.onclick = () => this.triggerSwipe('right');
      if(this.dislikeButton) this.dislikeButton.onclick = () => this.triggerSwipe('left');
      if(this.viewButton) this.viewButton.onclick = () => {
          const card = this.getCurrentCard();
          if(card && card.dataset.productUrl) window.location.href = card.dataset.productUrl;
      };
    }

    startDrag(event) {
      if (this.isAnimating) return;
      const card = this.getCurrentCard();
      if (!card || !card.contains(event.target)) return;
      if (event.target.closest('.swp16-footer') || event.target.closest('.swp16-header')) return;
      
      this.isDragging = true;
      this.isHorizontalSwipeLocked = false;
      this.currentCard = card;
      this.startPos.x = event.pageX || event.touches[0].pageX;
      this.startPos.y = event.pageY || event.touches[0].pageY;
      this.currentPos = { x: 0, y: 0 };
    }

    onDrag(event) {
      if (!this.isDragging || !this.currentCard) return;
      
      if(this.rAF) cancelAnimationFrame(this.rAF);

      this.rAF = requestAnimationFrame(() => {
          const currentX = event.pageX || (event.touches ? event.touches[0].pageX : 0);
          const currentY = event.pageY || (event.touches ? event.touches[0].pageY : 0);
          this.currentPos.x = currentX - this.startPos.x;
          this.currentPos.y = currentY - this.startPos.y;
          const xDiff = Math.abs(this.currentPos.x);
          const yDiff = Math.abs(this.currentPos.y);

          if (!this.isHorizontalSwipeLocked) {
              if (yDiff > xDiff && yDiff > 5) { this.isDragging = false; return; } 
              else if (xDiff > 5) { this.isHorizontalSwipeLocked = true; this.currentCard.classList.add('is-grabbing'); }
          }
          if (this.isHorizontalSwipeLocked) {
              const rotation = this.currentPos.x * 0.05;
              this.currentCard.style.transform = `translate(${this.currentPos.x}px, ${this.currentPos.y}px) rotate(${rotation}deg)`;
              const opacity = Math.min(Math.abs(this.currentPos.x) / 100, 1);
              const yes = this.currentCard.querySelector('.swp16-choice-yes');
              const no = this.currentCard.querySelector('.swp16-choice-no');
              if (this.currentPos.x > 0) { if(yes) yes.style.opacity = opacity; if(no) no.style.opacity = 0; } 
              else { if(no) no.style.opacity = opacity; if(yes) yes.style.opacity = 0; }
          }
      });
      
      if (this.isHorizontalSwipeLocked && event.cancelable) event.preventDefault();
    }

    endDrag(event) {
      if (!this.isDragging || !this.currentCard) return;
      if (this.rAF) cancelAnimationFrame(this.rAF);

      this.currentCard.classList.remove('is-grabbing');
      if (Math.abs(this.currentPos.x) > 100) this.dismissCard(this.currentPos.x > 0 ? 'right' : 'left');
      else this.resetCard(this.currentCard);
      this.isDragging = false;
      this.currentCard = null;
    }

    resetCard(card) {
          card.style.transition = 'transform 0.3s ease';
          card.style.transform = '';
          const yes = card.querySelector('.swp16-choice-yes');
          const no = card.querySelector('.swp16-choice-no');
          if(yes) yes.style.opacity = 0;
          if(no) no.style.opacity = 0;
          setTimeout(() => { card.style.transition = 'transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.3s'; }, 300);
    }

    triggerSwipe(direction) {
      if (this.isAnimating) return;
      const card = this.getCurrentCard();
      if(card) { this.currentCard = card; this.dismissCard(direction); }
    }

    dismissCard(direction) {
      this.isAnimating = true;
      const endX = direction === 'right' ? window.innerWidth : -window.innerWidth;
      const card = this.currentCard;
      const productId = card.dataset.productId;
      
      // --- LOGIQUE DE LIKE / RECOMMANDATION ---
      if (direction === 'right') {
          if(productId) this.likedIds.push(productId);
          this.recordPreference(card); 
          this.addToCart(card);
      }

      card.style.transition = 'transform 0.5s ease-out';
      card.style.transform = `translate(${endX}px, 50px) rotate(${direction === 'right' ? 20 : -20}deg)`;
      setTimeout(() => {
        card.remove(); 
        this.cards.shift(); 
        this.updateHeaderInfo(this.getCurrentCard());
        this.checkBuffer(); 
        this.isAnimating = false;
        this.currentCard = null;
      }, 300);
    }

    addToCart(card) {
        const variantId = card.dataset.variantId;
        if(!variantId || variantId === "undefined") return; 
        
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        formData.append('sections', 'cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);

        fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData })
        .then(response => { 
             if (response.ok) return response.json(); 
             throw new Error('Stock'); 
        })
        .then(data => {
            if(this.successOverlay) { 
                this.successOverlay.classList.add('is-visible'); 
                setTimeout(() => this.successOverlay.classList.remove('is-visible'), 1500); 
            }
            if(data.sections && data.sections['cart-icon-bubble']) {
                const bubble = document.getElementById('cart-icon-bubble');
                if(bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
            }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, vertical: true }));
        })
        .catch(e => console.error(e));
    }
  }

  document.addEventListener('DOMContentLoaded', () => { document.querySelectorAll('.swiper-section-v16').forEach(el => new ProductSwiper_V16(el)); });
  document.addEventListener('shopify:section:load', () => { document.querySelectorAll('.swiper-section-v16').forEach(el => new ProductSwiper_V16(el)); });

  } catch(e) { console.error(e); }
})();
})();
